export module Selectors {
    export const videoElementId = "rf_webcam";
    export const canvasElementId = "rf_canvas";
    export const canvasSecondElementId = "rfr_canvas";
    export const modalSelector = '#modal-rostro';
    export const modalOverlaySelector = '.modal-overlay';
    export const buttonInitRegisterSelector = '.button-rostro';
    export const camContainerSelector = '.cam-container';
    export const errorWebcamContainerSelector = '.msg-error-webcam-container'
    export const msgContainerSelector = '.msg-container'
    export const camRegisterContainerSelector = '.camregister-container';
    export const initScanBtnSelector = '.button-comenzar-rostro';
    export const personSvgSelector = ".icon-person";
    export const inputImagesName = "rf_images";
    export const generalStepSelector = '.step';
    export const iconArrowGeneralSelector = '.icon-arrow-';
    export const registroPorcentajeSelector = '.registro-porcentaje';
}